jQuery(function($){
	$('.co-tile-wrapper').on('click', '.co-tile.availability .availability-status', function(){
		let parentWrapper = $(this).closest('.co-tile-wrapper');
		let memberTile = $(this).closest('.co-tile');

		let wasExpanded = memberTile.hasClass('expanded');

		$('.co-tile.availability').each(function(){
			$(this).removeClass('expanded');
		});

		if(!wasExpanded) memberTile.addClass('expanded');
	});

	$('.co-tile-wrapper').on('click', '.co-tile.availability .availability-status-update .update-button', function(){
		console.log(this.classList);
		let parentWrapper = $(this).closest('.co-tile-wrapper');
		let memberTile = $(this).closest('.co-tile');

		let buttonStatus = $(this).attr('status');
		let commentsDiv = $(this).closest('.availability-status-update').find('.comments');

		memberTile.removeClass('expanded going maybe not_going no_answer').addClass(buttonStatus);

		let comments = '';
		$.each(commentsDiv, function(index, div){
			comments += $(this).val();
		});
		console.log(comments);

		let partColumn = $(this).closest('.part');
		let part = memberTile.attr('part');

		let memberId = memberTile.attr('member_id');
		let eventId = memberTile.attr('event_id');
		let memberStatus = memberTile.attr('status');

		let toColumn = '.responses .part[part=' + part + '] .status[status=' + buttonStatus + ']';

		let data = {
			action: 'choralorg_availability_update_record',
			member_id: memberId,
			event_id: eventId,
			comments: comments,
			status: buttonStatus
		};

		console.log(data);

		if(buttonStatus == 'no_answer') {
			data.remove = true;
			toColumn = '.uncounted-members .part[part=' + part + '] .status[status=' + memberStatus + ']';
		}

		$(toColumn).each(function(){
			addToColumn($(this), memberTile, toColumn);
		});

		$.post('/wp-admin/admin-ajax.php', data, function(response){
			console.log(response);
			memberTile.find('.subtitle .status').html(response);
		});

		updateAttendanceTotals();
	});

	function addToColumn(column, memberTile, toColumn) {
		memberTile.detach().appendTo(toColumn);
		sortToColumn(column);
	}

	function sortToColumn(column) {
		columnItems = [];
		column.find('.co-tile').each(function(){
			columnItems.push({
				first_name: $(this).attr('first_name'),
				last_name: $(this).attr('last_name'),
				el: $(this)
			});
			$(this).remove();
		});

		columnItems.sort(sortByName);
		$.each(columnItems, function(index, value){
			column.append(value.el);
		});
	}

	function sortByName(a, b) {
		let keys = [
			'last_name',
			'first_name'
		];

		let returnValue = 0;
		$.each(keys, function(index, value){
			returnValue = compareValues(a, b, value);
			if(returnValue != 0) return false;
		});
		return returnValue;		
	}

	function compareValues(a, b, key) {
		if(a[key] < b[key]) return -1;
		if(a[key] > b[key]) return 1;
		return 0;		
	}

	function updateAttendanceTotals() {
		let totals = {
			going: 0,
			maybe: 0,
			not_going: 0
		};

		let statusName;

		$('.column-attendance-total').each(function(){
			let parentDiv = $(this).closest('.status');
			let total = parentDiv.find('.co-tile').length;

			statusName = parentDiv.attr('status');

			if(total > 0) {
				parentDiv.removeClass('empty');
			} else {
				parentDiv.addClass('empty');
			}

			$(this).html(total);

			totals[statusName] += total;
		});

		$.each(totals, function(key, value){
			$('.list-stats .list-stat.' + key + ' .count').html(value);
		});
	}

	$('.co-tile .log-button').on('click', function(){
		const target = $(this).attr('popup_target');
		$(this).closest('.co-tile').find('.log-modal[popup_id="' + target + '"]').addClass('showing');
	});

	$('.co-report-wrapper .report-cell').on('click', '.log-button.not-loaded', function(){
		const el = $(this);

		const post = el.attr('post');

		const modalContentDiv = el.closest('.report-cell').find('.log-modal .log-modal-window');

		modalContentDiv.html('<span class="fas fa-cog fa-spin"></span> Loading...');

		const data = {
			action: 'choralorg__availability__get_modal_log',
			post: post,
		};

		$.post('/wp-admin/admin-ajax.php', data, function(response){
			console.log(response);
			const responseJson = JSON.parse(response);
			console.log(responseJson);

			el.removeClass('not-loaded');
			modalContentDiv.html(responseJson.html);
		});
	});

	$('.co-tile .log-modal .log-modal-bg').on('click', function(){
		closeAttendanceLogModal($(this));
	});

	function closeAttendanceLogModal(el) {
		el.closest('.log-modal').removeClass('showing');
	} 

	$('#co-availability-report .skew.corner #show-fractions').on('change', function(){
		const parentDiv = $(this).closest('table');
		if(this.checked) {
			parentDiv.addClass('showing-fractions');
		} else {
			parentDiv.removeClass('showing-fractions');
		}
	});

	$('#co-availability-report .skew.corner #show-availability-details').on('change', function(){
		const parentDiv = $(this).closest('table');
		if(this.checked) {
			parentDiv.addClass('showing-availability-details');
		} else {
			parentDiv.removeClass('showing-availability-details');
		}
	});
	
	$('.part-row .toggle-part').on('click', function(){
		const parentDiv = $(this).closest('.part-row');
		const table = $(this).closest('table');
		const toggle = parentDiv.attr('toggle_class');
		const memberRows = table.find('.member-row.part--' + toggle);
		const wasToggledOff = parentDiv.hasClass('toggled-off');
		console.log(wasToggledOff)
				parentDiv.addClass('toggled-off');

		setTimeout(function(){
			if(wasToggledOff) {
				parentDiv.removeClass('toggled-off');
				memberRows.removeClass('toggled-off');
			} else {
				parentDiv.addClass('toggled-off');
				memberRows.addClass('toggled-off');
			}
		}, 50);
	});

	$('#choralorg-wrapper').on('click', '.log-modal-window .add-log-wrapper .add-log-button', function(){
		const parentDiv = $(this).closest('.add-log-wrapper');
		parentDiv.toggleClass('showing');
		console.log(parentDiv.attr('avail_id'));
	});

	$('#choralorg-wrapper').on('click', '.log-modal-window .add-log-wrapper .log-status-update .update-button', function(){
		const modalDiv = $(this).closest('.log-modal-window');
		const wrapperDiv = $(this).closest('.add-log-wrapper');
		const parentDiv = $(this).closest('.log-status-update');
		const tableHeaderRow = modalDiv.find('.log-table .log-entry.headers');
		const button = wrapperDiv.find('.add-log-button');

		const buttonHtml = button.html();
		button.html('<span class="fas fa-cog fa-spin"></span> Updating...');
		wrapperDiv.removeClass('showing');

		const data = {
			action: 'choralorg__availability__add_log_entry_from_modal',
			avail_id: wrapperDiv.attr('avail_id'),
			member_id: wrapperDiv.attr('member_id'),
			event_id: wrapperDiv.attr('event_id'),
			status: $(this).attr('status'),
			comments: parentDiv.find('.comments').val(),
		};

		$.post('/wp-admin/admin-ajax.php', data, function(response){
			console.log(response);
			const responseJson = JSON.parse(response);
			console.log(responseJson);

			tableHeaderRow.after(responseJson.output);
			button.html(buttonHtml);

			if(!wrapperDiv.attr('avail_id')) {
				wrapperDiv.attr('avail_id', responseJson.post_id);
			}
		});
	});
});